module.exports = __webpack_public_path__ + "img/wudingdan@2x.b343c312.png";